import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import { OrderProductOptionValue, OrderProductOption } from 'PMT/entities/order';

export default class OrderProductOptionView extends Component {

  static propTypes = {
    orderProductOptionValue: PropTypes.objectOf(OrderProductOptionValue).isRequired,

    orderProductOption: PropTypes.objectOf(OrderProductOption).isRequired,

    quantity: PropTypes.number.isRequired
  };

  render() {
    const className = classNames('order_product_option_value_view', {
      'order_product_option_value_view__with_price': this.props.orderProductOptionValue.additionalPrice > 0
    });

    return (
      <div className={className}>
        {this.props.quantity > 0 &&
          <div className="order_product_option_value_view__quantity">
            {this.props.quantity}
          </div>
        }
        <div className="order_product_option_value_view__name">
          {this.props.orderProductOptionValue.name}

          <div className="order_product_option_value_view__product_option_name">
            {this.props.orderProductOption.name}
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/components/order/orderDetailModal/OrderProductOptionValueView.js